import React, { Component } from 'react';
import classes from './Articles.module.css';
import Card from '../Card/Card';
import HorizontalBar from '../HorizontalBar/HorizontalBar';

class Articles extends Component {
  state = {
    articles: [
      {
        articleTitle: 'Verifying requests from Slack using Node.js',
        link:
          'https://medium.com/@rajat_sriv/verifying-requests-from-slack-using-node-js-69a8b771b704'
      },
      {
        articleTitle: 'Parsing Gigabytes of JSON per second',
        link: 'https://medium.com/@rajat_sriv/parsing-gigabytes-of-json-per-second-9c5a1a7b91db'
      }
    ]
  };

  render() {
    const { articles } = this.state;
    const articleList = articles.map((article, index) => (
      <div className={classes.SingleArticle} key={article.link}>
        {index === 0 ? null : <HorizontalBar />}
        <a href={article.link} target="_blank" rel="noopener noreferrer">
          <h2>{article.articleTitle}</h2>
        </a>
      </div>
    ));
    return (
      <Card eventTypes="click" goBack={this.props.history.goBack}>
        <h1>Articles</h1>
        <div className={classes.Articles}>{articleList}</div>
      </Card>
    );
  }
}

export default Articles;
